import { Tag, Tooltip } from '@chakra-ui/react';

const PremiumFeatureTag = ({ tooltip }: { tooltip?: string }) => {
  const tag = (
    <Tag
      bg="purple.100"
      color="purple.700"
      borderRadius="full"
      px={3}
      py={0.5}
      fontSize="12px"
      fontWeight="600"
    >
      Premium feature
    </Tag>
  );

  if (!tooltip) {
    return tag;
  }

  return (
    <Tooltip
      label={tooltip}
      hasArrow
      placement="top"
      fontSize="12px"
      bg="inkBlue"
      color="white"
      borderRadius="6px"
      textAlign="center"
      p="10px"
    >
      {tag}
    </Tooltip>
  );
};

export default PremiumFeatureTag;
